(ns ncr.reports.common
  (:require
   [clojure.core.match :refer [match]]
   [ncr.cube :as cube]
   [ncr.symbolic :as sym]))

(def months
  ["Jan" "Feb" "Mar" "Apr" "May" "Jun" "Jul" "Aug" "Sep" "Oct" "Nov" "Dec"])

(def months-long
  ["January" "February" "March" "April" "May" "June" "July" "August" "September" "October" "November" "December"])

(defn from-path [report path]
  (match path
    {:report-path report-path :cube-path cube-path :sym-path sym-path :month month :kind kind}
    (from-path report {:report-path report-path :cube-path (conj cube-path month) :sym-path (into [kind] sym-path)})

    {:report-path report-path :cube-path cube-path :sym-path sym-path}
    (some-> report
      (get-in report-path)
      (cube/cell cube-path true)
      (sym/get-path sym-path))

    {:report-path report-path}
    (get-in report report-path)))

(defn income-expense-pnl-paths [path]
  (map (partial assoc path :sym-path) [[:income] [:expense] []]))
